import { faTimes } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useIsMounted } from "@outschool/ui-utils";
import React from "react";
import ReactDOM from "react-dom";

import IconButton from "./IconButton";
import LegacyBox from "./LegacyBox";
import LegacyFlex from "./LegacyFlex";

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
  renderHeader?: () => React.ReactNode;
  children: React.ReactNode;
  zIndex?: number;
  sx?: any;
  portalSx?: any;
}
export default function MobileDrawer({
  open,
  onClose,
  renderHeader = () => null,
  children,
  zIndex = 2000,
  portalSx = {},
  sx = {},
}: MobileDrawerProps): React.ReactElement | null {
  const { t } = useTranslation("ui-legacy-component-library");
  const isMounted = useIsMounted();

  return !isMounted
    ? null
    : ReactDOM.createPortal(
        <LegacyBox>
          <LegacyBox
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              backgroundColor: "rgba(0,0,0,0.6)",
              zIndex,
              pointerEvents: open ? "initial" : "none",
              opacity: open ? 1 : 0,
              transition: "opacity 0.3s ease",
              ...portalSx,
            }}
            onClick={onClose}
          />
          <LegacyFlex
            sx={{
              flexDirection: "column",
              position: "fixed",
              right: open ? 0 : "-100vw",
              top: 0,
              bottom: 0,
              backgroundColor: "white",
              zIndex: zIndex + 1,
              transition: "right 0.3s ease",
              minWidth: "75vw",
              ...sx,
            }}
          >
            <LegacyFlex
              sx={{
                padding: "small",
                justifyContent: "space-between",
                borderBottom: "1px solid",
                borderColor: "headerBorder",
              }}
            >
              <LegacyBox>{renderHeader()}</LegacyBox>
              <IconButton
                sx={{}}
                aria-label={t("Close")}
                icon={faTimes}
                iconProps={{ sx: { fontSize: "1.333em" } }}
                onClick={onClose}
              />
            </LegacyFlex>
            {children}
          </LegacyFlex>
        </LegacyBox>,
        document.body
      );
}
